const map = {
	"./NextCab_Fahrzeug.png": 4904,
	"./NextCab_Schriftzug.png": 957,
	"./hauptlogo.png": 4189,
	"./hauptlogo_beschnitten.png": 7413,
	"./schriftzug.png": 6831,
	"./taxi-map.jpg": 545
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;